import { ACTION_BUTTONS_NAME } from "constants/generalActionButtons";
import {
  ACTIONS,
  CATEGORIES,
  COMPONENT_NAMES,
  CONTEXTS,
  EVENT_NAMES,
  sendEvent,
} from "./googleAnalyticsHelper";

/** @typedef {"dropdown" | "context_menu" | "row_icon"} AuditTrailEventSource */

const AUDIT_TRAIL_SURFACE_SUFFIX = {
  dropdown: "Menu",
  context_menu: "ContextMenu",
  row_icon: "Icon",
};

const MENU_KEY_TO_EVENT_BY_SURFACE = {
  [ACTION_BUTTONS_NAME.COPY_SHORTHAND.key]: {
    Menu: EVENT_NAMES.AUDIT_TRAIL_COPY_SHORTHAND_MENU,
    ContextMenu: EVENT_NAMES.AUDIT_TRAIL_COPY_SHORTHAND_CONTEXT_MENU,
    Icon: EVENT_NAMES.AUDIT_TRAIL_COPY_SHORTHAND_ICON,
  },
  [ACTION_BUTTONS_NAME.COPY_SHORTHAND_LEGS.key]: {
    Menu: EVENT_NAMES.AUDIT_TRAIL_COPY_SHORTHAND_LEGS_MENU,
    ContextMenu: EVENT_NAMES.AUDIT_TRAIL_COPY_SHORTHAND_LEGS_CONTEXT_MENU,
  },
  [ACTION_BUTTONS_NAME.COPY_SHORTHAND_NO_VOLS.key]: {
    Menu: EVENT_NAMES.AUDIT_TRAIL_COPY_SHORTHAND_NO_VOLS_MENU,
    ContextMenu: EVENT_NAMES.AUDIT_TRAIL_COPY_NO_VOLS_CONTEXT_MENU,
  },
  [ACTION_BUTTONS_NAME.PULL_TO_PRICER.key]: {
    Menu: EVENT_NAMES.AUDIT_TRAIL_PULL_TO_PRICER_MENU,
    ContextMenu: EVENT_NAMES.AUDIT_TRAIL_PULL_TO_PRICER_CONTEXT_MENU,
    Icon: EVENT_NAMES.AUDIT_TRAIL_PULL_TO_PRICER_ICON,
  },
  [ACTION_BUTTONS_NAME.TRADE.key]: {
    Menu: EVENT_NAMES.AUDIT_TRAIL_TRADE_MENU,
    ContextMenu: EVENT_NAMES.AUDIT_TRAIL_TRADE_CONTEXT_MENU,
  },
  [ACTION_BUTTONS_NAME.ADDITIONAL_DATA.key]: {
    Menu: EVENT_NAMES.AUDIT_TRAIL_ADDITIONAL_DATA_MENU,
    ContextMenu: EVENT_NAMES.AUDIT_TRAIL_ADDITIONAL_DATA_CONTEXT_MENU,
  },
  [ACTION_BUTTONS_NAME.DETAILED_AUDIT_TRIAL.key]: {
    Menu: EVENT_NAMES.AUDIT_TRAIL_DETAILED_AUDIT_TRAIL_MENU,
    ContextMenu: EVENT_NAMES.AUDIT_TRAIL_DETAILED_AUDIT_TRAIL_CONTEXT_MENU,
  },
  [ACTION_BUTTONS_NAME.COPY_TRADE_DETAILS.key]: {
    Menu: EVENT_NAMES.AUDIT_TRAIL_COPY_TRADE_DETAILS_MENU,
    ContextMenu: EVENT_NAMES.AUDIT_TRAIL_COPY_TRADE_DETAILS_CONTEXT_MENU,
    Icon: EVENT_NAMES.AUDIT_TRAIL_COPY_TRADE_DETAILS_ICON,
  },
  [ACTION_BUTTONS_NAME.EDIT_TRADE_DETAILS.key]: {
    Menu: EVENT_NAMES.AUDIT_TRAIL_EDIT_TRADE_DETAILS_MENU,
    ContextMenu: EVENT_NAMES.AUDIT_TRAIL_EDIT_TRADE_DETAILS_CONTEXT_MENU,
  },
  [ACTION_BUTTONS_NAME.VOID.key]: {
    Menu: EVENT_NAMES.AUDIT_TRAIL_VOID_OPEN_MENU,
    ContextMenu: EVENT_NAMES.AUDIT_TRAIL_VOID_OPEN_CONTEXT_MENU,
  },
  filter_matches: {
    Menu: EVENT_NAMES.AUDIT_TRAIL_FILTER_MATCHES_MENU,
    ContextMenu: EVENT_NAMES.AUDIT_TRAIL_FILTER_MATCHES_CONTEXT_MENU,
  },
};

/**
 * @param {string} menuKey
 * @param {AuditTrailEventSource} [source]
 */
export function getAuditTrailEventName(menuKey, source = "dropdown") {
  const surface = AUDIT_TRAIL_SURFACE_SUFFIX[source] ?? "Menu";
  return MENU_KEY_TO_EVENT_BY_SURFACE[menuKey]?.[surface] ?? null;
}

/**
 * @param {string} menuKey — `ACTION_BUTTONS_NAME.*.key` or `filter_matches`
 * @param {{ source?: AuditTrailEventSource, page?: string }} opts
 */
export function trackAuditTrailMenuKey(menuKey, opts = {}) {
  const { source = "dropdown", page = "audit_trail" } = opts;
  const eventName = getAuditTrailEventName(menuKey, source);
  if (!eventName) return;

  sendEvent({
    category: CATEGORIES.AUDIT_TRAIL,
    context: CONTEXTS.AUDIT_TRAIL_ACTION_MENU,
    action: ACTIONS.CLICK,
    component:
      source === "row_icon"
        ? COMPONENT_NAMES.ICON_BUTTON
        : COMPONENT_NAMES.MENU_BUTTON,
    eventName,
    extraParams: { page },
  });
}

export function trackAuditTrailClearing(eventName, extraParams = {}) {
  sendEvent({
    category: CATEGORIES.AUDIT_TRAIL,
    context: CONTEXTS.AUDIT_TRAIL_ACTION_MENU,
    action: ACTIONS.CLICK,
    component: COMPONENT_NAMES.MENU_BUTTON,
    eventName,
    extraParams,
  });
}

export function trackAuditTrailVoidSuccess(extraParams = {}) {
  sendEvent({
    category: CATEGORIES.AUDIT_TRAIL,
    context: CONTEXTS.AUDIT_TRAIL_ACTION_MENU,
    action: ACTIONS.CLICK,
    component: COMPONENT_NAMES.MENU_BUTTON,
    eventName: EVENT_NAMES.AUDIT_TRAIL_VOID_CONFIRM,
    extraParams,
  });
}
